import React from 'react';
import { View } from 'react-native';
import { Text } from '@shared/components/text';
import { CHAT_UNREAD_BADGE_MAX } from '../../constants';
import type { TChatUnreadBadgeProps } from '../../types';

export const ChatUnreadBadge = ({ count }: TChatUnreadBadgeProps) => (
    <View className="w-[42px] h-[26px] rounded-full bg-secondary-600 items-center justify-center">
        <Text className="text-sm font-bold text-white leading-none">
            {count > CHAT_UNREAD_BADGE_MAX ? `${CHAT_UNREAD_BADGE_MAX}+` : count}
        </Text>
    </View>
);
